<div class="row">
  <label class="me-2">{{ 'i18n.shared.fields.assigned-parkers' | translate }}:</label>
</div>
<div class="row">
  <div class="col-12">
    <ejs-grid #grid
              class="grid-with-footer"
              width="100%"
              rowHeight="38"
              [allowPaging]="true"
              [dataSource]="linkedParkers"
              (commandClick)="commandClicked($event)">
      <e-columns>
        <e-column headerText='id' field='id' [visible]='false' [isPrimaryKey]='true'></e-column>
        <e-column [headerText]="'i18n.shared.fields.parkerId' | translate" field="parkerId" clipMode='EllipsisWithTooltip'></e-column>
        <e-column [headerText]="'i18n.shared.fields.parkerName' | translate" field="parkerName" clipMode='EllipsisWithTooltip'>
          <ng-template #template let-data>
            <span>{{data.firstName}} {{data.lastName}}</span>
          </ng-template>
        </e-column>
        <e-column [headerText]="'i18n.shared.fields.companyOrClient' | translate" field="company.name" clipMode='EllipsisWithTooltip'>
          <ng-template #template let-data>
            <span>{{data.company?.name ?? data.client?.name}}</span>
          </ng-template>
        </e-column>
        <e-column headerText="" [commands]='gridCommands' width='100px'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
